const NEXT_PROCESS_STEP = 'NEXT_PROCESS_STEP';
const PREVIOUS_PROCESS_STEP = 'PREVIOUS_PROCESS_STEP';
const ALL_PROCESS_STEP = 'ALL_PROCESS_STEP';

export {
  NEXT_PROCESS_STEP,
  PREVIOUS_PROCESS_STEP,
  ALL_PROCESS_STEP,
};
